<template>
  <md-dialog
    :md-active.sync="showDialog"
    :md-close-on-esc="false"
    :md-click-outside-to-close="false"
    class="arrange-dialog"
  >
    <md-dialog-title>Sắp xếp sản phẩm</md-dialog-title>
    <div class="md-layout w-full">
      <div class="md-layout-item md-size-75">
        <md-table
          :value="products"
          class="table-products table-hover"
          table-header-color="green"
          md-fixed-header
          md-height="50vh"
        >
          <md-table-row
            slot="md-table-row"
            slot-scope="{ item }"
            class="clickable"
            :draggable="true"
            @dragstart="startDragItem(item)"
            @dragover="(e) => e.preventDefault()"
            @drop="dropItem(item)"
          >
            <md-table-cell
              md-label="Mã sản phẩm"
              class="table-cell"
              align="left"
            >
              {{ item.data.productId }}
            </md-table-cell>
            <md-table-cell
              md-label="Tên sản phẩm"
              class="table-cell"
              align="left"
            >
              {{ item.data.name }}
            </md-table-cell>
            <md-table-cell
              md-label="Hình ảnh"
              class="table-cell"
              align="center"
            >
              <div class="image-container">
                <img :src="item.data.pictureThumbnail" class="box-image" />
              </div>
            </md-table-cell>
            <md-table-cell
              md-label="Sắp xếp"
              class="table-cell"
              align="center"
              style="min-width: 200px"
            >
              <md-button
                class="md-icon-button md-raised md-primary"
                @click="moveUpItem(item)"
              >
                <md-icon>arrow_upward</md-icon>
                <md-tooltip md-delay="300">Lên trên</md-tooltip>
              </md-button>
              <md-button
                class="md-icon-button md-raised md-primary"
                @click="moveDownItem(item)"
              >
                <md-icon>arrow_downward</md-icon>
                <md-tooltip md-delay="300">Xuống dưới</md-tooltip>
              </md-button>
              <md-button
                class="md-icon-button md-raised md-primary"
                @click="moveToTop(item)"
              >
                <md-icon>upload</md-icon>
                <md-tooltip md-delay="300">Lên cùng</md-tooltip>
              </md-button>
              <md-button
                class="md-icon-button md-raised md-primary"
                @click="moveToBot(item)"
              >
                <md-icon>download</md-icon>
                <md-tooltip md-delay="300">Dưới cùng</md-tooltip>
              </md-button>
            </md-table-cell>
          </md-table-row>
        </md-table>
      </div>
      <div class="md-layout-item md-size-25 text-center">
        <div class="iphone" id="iphone">
          <div
            class="w-full list-item-container"
            style="overflow: auto; height: 100%"
          >
            <transition-group name="flip-list" class="w-full flex-sa flex-w">
              <div
                v-for="item in products"
                :key="item.id"
                class="w-25 m-5 p-5 product-thumbnail"
                style="background: #fff"
                :draggable="true"
                @dragstart="startDragItem(item)"
                @dragover="(e) => e.preventDefault()"
                @drop="dropItem(item)"
              >
                <img
                  :src="item.data.pictureThumbnail"
                  :alt="item.data.name"
                  style="height: 65px"
                />
              </div>
            </transition-group>
          </div>
        </div>
      </div>
    </div>
    <md-dialog-actions>
      <md-button class="md-sm" @click="$emit('closeDialog')"> Đóng </md-button>
      <md-button
        class="md-primary md-sm"
        @click="changeProductsIndex()"
        :disabled="!isChange"
      >
        Lưu
      </md-button>
    </md-dialog-actions>
  </md-dialog>
</template>
<script>
import Modal from "./Modal.vue";
import { mapGetters } from "vuex";
import Swal from "sweetalert2";
export default {
  name: "arrange-item",
  props: {
    showDialog: Boolean,
  },
  components: {
    Modal,
  },
  data() {
    return {
      products: [],
      itemDragging: null,
      isChange: false,
      listUpdate: [],
    };
  },
  created() {
    if (this.$route.name === "Quản lý sản phẩm") {
      this.products = [...this.$listProducts];
    } else this.products = [...this.accessories];
    this.products = this.products.filter((item) => !item.data.isHide);
    this.products.sort((a, b) => a.data.index - b.data.index);
  },
  computed: {
    ...mapGetters(["$listProducts", "accessories"]),
    itemArrangementType() {
      return this.$route.name === "Quản lý sản phẩm" ? "wines" : "accessories";
    },
  },
  methods: {
    setListUpdates(start, end) {
      for (let i = start; i <= end; i++) {
        if (!this.listUpdate.includes(i)) this.listUpdate.push(i);
      }
    },
    moveUpItem(item) {
      var index = this.products.findIndex((e) => e.id === item.id);
      if (index !== -1 && index !== 0) {
        var tmp = JSON.parse(JSON.stringify(this.products[index]));
        this.$set(this.products, index, this.products[index - 1]);
        this.$set(this.products, index - 1, tmp);
        this.isChange = true;
        this.setListUpdates(index - 1, index);
      }
    },
    moveDownItem(item) {
      var index = this.products.findIndex((e) => e.id === item.id);
      if (index !== -1 && index !== this.products.length - 1) {
        var tmp = JSON.parse(JSON.stringify(this.products[index]));
        this.$set(this.products, index, this.products[index + 1]);
        this.$set(this.products, index + 1, tmp);
        this.isChange = true;
        this.setListUpdates(index, index + 1);
      }
    },
    moveToTop(item) {
      var index = this.products.findIndex((e) => e.id === item.id);
      if (index === 0) return;
      var tmp = this.products.splice(index, 1);
      this.products.unshift(tmp[0]);
      this.isChange = true;
      this.setListUpdates(0, index);
    },
    moveToBot(item) {
      var index = this.products.findIndex((e) => e.id === item.id);
      if (index === this.products.length - 1) return;
      var tmp = this.products.splice(index, 1);
      this.products.push(tmp[0]);
      this.isChange = true;
      this.setListUpdates(index, this.products.length - 1);
    },
    startDragItem(item) {
      this.itemDragging = this.products.findIndex((e) => e.id === item.id);
    },
    dropItem(item) {
      let index = this.products.findIndex((e) => e.id === item.id);
      let tmp = this.products.splice(this.itemDragging, 1)[0];
      this.products.splice(index, 0, tmp);
      this.isChange = true;
      if (index < this.itemDragging)
        this.setListUpdates(index, this.itemDragging);
      else this.setListUpdates(this.itemDragging, index);
    },
    updateProduct(product) {
      if (this.itemArrangementType === "wines")
        return this.$store.dispatch("updateProduct", product);
      else return this.$store.dispatch("updateAccessory", product);
    },
    changeProductsIndex() {
      let listSuccess = [];
      let listError = [];
      for (let i = 0; i < this.products.length; i++) {
        if (this.listUpdate.includes(i)) {
          this.$set(this.products[i].data, "index", i);
          this.updateProduct(this.products[i])
            .then(() => {
              listSuccess.push(this.products[i]);
              Swal.fire({
                title: `Cập nhật thành công ${listSuccess.length}, lỗi ${listError.length}`,
              });
            })
            .catch(() => {
              listError.push(this.products[i]);
            });
        }
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.iphone {
  color: #fff;
  text-align: center;
  font-family: "SF Pro Display", Helvetica Neue, Arial, sans-serif;
  letter-spacing: -0.022em;
  font-size: 2.5vmin;
  text-shadow: 0 0 0.5em #000;
  background-color: #000;
  background-size: auto 200%, cover;
  background-repeat: no-repeat, no-repeat;
  border: solid #111;
  margin-bottom: 2em;
  position: relative;
  box-shadow: 0 0.5em 2em 0.2em rgba(0, 0, 0, 0.33), 0 0 0 0.5px #000 inset;
  transition: all 0.1s linear, line-height 0s linear;
  background-position: 50% 100%, center;
  transform-origin: bottom center;
  $unit: 70vmin/2.525;
  width: $unit;
  height: 2.15 * $unit;
  border-width: $unit/90.625;
  border-radius: $unit/5.86;
  background: #fff;
  overflow: hidden;
  padding: 25px 0 10px 0;
  .list-item-container {
    background-color: rgb(156, 156, 156);
    .flip-list-move {
      transition: transform 0.4s;
    }
    .product-thumbnail {
      background: #fff;
      border-radius: 10px;
      overflow: hidden;
    }
  }
}
</style>
